export default {
  'me.app_bar.title': 'Oma työpöytä',
  'me.nav.desktop': 'Oma työpöytä',
  'me.nav.companies': 'Omat yritykset',
  'me.nav.approvals': 'Omat hyväksynnät',
  'me.nav.tasks': 'Omat tehtävät',
  'me.host_company': 'Isäntäyritys',
  'me.host_company_none': 'Ei isäntäyrityksiä',
  'me.back_to_app': 'Takaisin sovellukseen',
  'me.back_to_tenant': 'Takaisin: {{name}}',
  'me.cards.all_companies.title': 'Tilitoimisto',
  'me.cards.all_companies.description': 'Erääntyvät työt ja saldokattavuus yritysten välillä.',
  'me.cards.companies.title': 'Omat yritykset',
  'me.cards.companies.description': 'Kaikki yritykset, joihin sinulla on pääsy — klikkaa vaihtaaksesi.',
  'me.cards.approvals.title': 'Omat hyväksynnät',
  'me.cards.approvals.description': 'Hyväksy tai hylkää odottavat kohteet kaikissa yrityksissäsi.',
  'me.cards.tasks.title': 'Omat tehtävät',
  'me.cards.tasks.description': 'Avoimet sinulle osoitetut tehtävät kaikissa yrityksissäsi.',
  'me.cards.user_settings.title': 'Käyttäjäasetukset',
  'me.cards.user_settings.description': 'Profiili, salasana, kieli, ilmoitukset.',
  'me.companies.empty': 'Sinulla ei ole vielä yritysoikeuksia.',
  'me.companies.current': 'Nykyinen',
  'me.companies.tenant': 'Yritys',
  'me.companies.host': 'Isäntä',
  'me.companies.slug': 'Tunniste',
  'me.companies.status': 'Tila',
  'me.companies.active': 'Aktiivinen',
  'me.companies.inactive': 'Ei aktiivinen',
  'me.approvals.no_hosts': 'Sinulla ei ole vielä yritysoikeuksia.',
  'me.approvals.empty': 'Ei odottavia hyväksyntöjä.',
  'me.approvals.tenant': 'Yritys',
  'me.approvals.entity': 'Kohde',
  'me.approvals.invoice_image': 'Kuva',
  'me.approvals.preview_unavailable': 'Tiedostoa ei voi esikatsella. Avaa lasku nähdäksesi sen liitteet.',
  'me.tasks.no_hosts': 'Sinulla ei ole vielä yritysoikeuksia.',
  'me.tasks.empty': 'Ei avoimia sinulle osoitettuja tehtäviä.',
  'me.tasks.tenant': 'Yritys',
  'me.tasks.identifier': 'Tunnus',
  'me.tasks.name': 'Tehtävä',
  'me.tasks.stage': 'Vaihe',
  'me.tasks.deadline': 'Määräaika',
};
